export const LOTTERY_MENUS = [
  {
    _id: '6659516320a51e926bd93339',
    component_content_id: '63806c9840b4a5aea422f05f',
    title: {
      'en-US': '/',
      'th-TH': '5',
      'vi-VN': null,
      'zh-CN': '1',
      'my-MM': 'Test'
    },
    description: {
      'en-US': '/',
      'th-TH': '5',
      'vi-VN': null,
      'zh-CN': '1',
      'my-MM': 'Test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    sequence: 2,
    image_desktop_path: {
      'en-US': 'demo/games/lottery/image-1-en.png',
      'th-TH': 'demo/games/lottery/image-1-th.png',
      'zh-CN': 'demo/games/lottery/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/lottery/image-1-en-mobile.png',
      'th-TH': 'demo/games/lottery/image-1-th-mobile.png',
      'zh-CN': 'demo/games/lottery/image-1-ch-mobile.png'
    },
    image_path: {},
    link: {}
  },
  {
    _id: '6841a0f54d76ce42906e9d5a',
    component_content_id: '63806c9840b4a5aea422f05f',
    title: {
      'en-US': 'Thai lottery'
    },
    description: {
      'en-US': 'Thai lottery'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: '1',
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/lottery/image-2-en.png',
      'th-TH': 'demo/games/lottery/image-2-th.png',
      'zh-CN': 'demo/games/lottery/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/lottery/image-2-en-mobile.png',
      'th-TH': 'demo/games/lottery/image-2-th-mobile.png',
      'zh-CN': 'demo/games/lottery/image-2-ch-mobile.png'
    }
  },
  {
    _id: '684fa0f53d76ce42906e9d5a',
    component_content_id: '63806c9840b4a5aea422f05f',
    title: {
      'en-US': 'Thai lottery'
    },
    description: {
      'en-US': 'Thai lottery'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: '1',
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/lottery/image-3-en.png',
      'th-TH': 'demo/games/lottery/image-3-th.png',
      'zh-CN': 'demo/games/lottery/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/lottery/image-3-en-mobile.png',
      'th-TH': 'demo/games/lottery/image-3-th-mobile.png',
      'zh-CN': 'demo/games/lottery/image-3-ch-mobile.png'
    }
  },
  {
    _id: '684fa0f54d76ce42916e9d5a',
    component_content_id: '63806c9840b4a5aea422f05f',
    title: {
      'en-US': 'Thai lottery'
    },
    description: {
      'en-US': 'Thai lottery'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: '1',
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/lottery/image-4-en.png',
      'th-TH': 'demo/games/lottery/image-4-th.png',
      'zh-CN': 'demo/games/lottery/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/lottery/image-4-en-mobile.png',
      'th-TH': 'demo/games/lottery/image-4-th-mobile.png',
      'zh-CN': 'demo/games/lottery/image-4-ch-mobile.png'
    }
  },
  {
    _id: '684fa0f54d76ce42906e9d1a',
    component_content_id: '63806c9840b4a5aea422f05f',
    title: {
      'en-US': 'Thai lottery'
    },
    description: {
      'en-US': 'Thai lottery'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: '1',
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/lottery/image-5-en.png',
      'th-TH': 'demo/games/lottery/image-5-th.png',
      'zh-CN': 'demo/games/lottery/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/lottery/image-5-en-mobile.png',
      'th-TH': 'demo/games/lottery/image-5-th-mobile.png',
      'zh-CN': 'demo/games/lottery/image-5-ch-mobile.png'
    }
  }
]
